/* eslint-disable */
const awsmobile = {
    "aws_project_region": "ap-southeast-1",
    "aws_cognito_identity_pool_id": "ap-southeast-1:89f1f52b-021f-4b0e-a337-ddd0f686af71",
    "aws_cognito_region": "ap-southeast-1",
    "aws_user_pools_id": "ap-southeast-1_V0bSJVxRt",
    "aws_user_pools_web_client_id": "6d7p9cvap75jq4seustot19bvm",
    "oauth": {
        "domain": "loyal-prod.auth.ap-southeast-1.amazoncognito.com",
        "scope": ["email", "openid", "profile"],
        "redirectSignIn": "https://loyalty.pnj.com.vn/",
        "redirectSignOut": "https://loyalty.pnj.com.vn/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [],
    "aws_user_files_s3_bucket": "pnj-loyalty-img-prod",
    "aws_user_files_s3_bucket_region": "ap-southeast-1",
    "aws_cloud_logic_custom": [
        {
            "name": "pnjLoyalty",
            "endpoint": "https://dazxc1h9il.execute-api.ap-southeast-1.amazonaws.com/prod",
            "region": "ap-southeast-1"
        }
    ]
};

export default awsmobile;
